import dayjs from 'dayjs';

export function parseToStartOfMonth(selectedQuarterMonth: string): string {
  const date = dayjs(selectedQuarterMonth).startOf('month');

  return date.isValid() ? date.format('YYYY-MM-DD') : '';
}
